<div id="st-rating-leaderboard-point-leaderboard-container" class="point-leaderboard-container" [class.t1-page]="isTemplate1">
  <div id="st-rating-leaderboard-header-leaderboard" class="header-leaderboard">
    <span class="header-title">{{'rating_leaderboard' | translate}}</span>
    <div id="st-rating-leaderboard-search-and-buttons" class="search-and-buttons">
      <div id="st-rating-leaderboard-search-bar" class="search-bar">
           <img
          src="../../../assets/ranking-rating_assets/search.svg"
          alt="{{'search' | translate}}"
          class="search-icon"
        />
        <input
          type="text"
          placeholder="{{'search_player' | translate}}"
          [(ngModel)]="searchTerm"
          (input)="onSearch()"
        />
      </div>
      <div id="st-rating-leaderboard-button-group" class="button-group">
        <button
          class="filters-btn"
          [class.filters-active]="areFiltersApplied"
          (click)="toggleSidebar()" (keydown.enter)="toggleSidebar()" (keydown.space)="$event.preventDefault(); toggleSidebar()"
         tabindex="0">
          <img
            src="../../../assets/ranking-rating_assets/page_info.svg"
            alt="Filters"
            class="filter-icon"
          />

          <span class="filter-text">{{ 'filter' | translate }}</span>
          <button class="remove-filters" (click)="$event.stopPropagation(); removeFilters();" (keydown.enter)="$any($event).stopPropagation(); removeFilters();" (keydown.space)="$event.preventDefault(); $any($event).stopPropagation(); removeFilters();" *ngIf="areFiltersApplied" tabindex="0"><img src="../../../assets/ranking-rating_assets/close.svg" alt=""></button>
        </button>
        <div id="st-rating-leaderboard-filters-btn" *ngIf="ratingListLastUpdatedAt" class="filters-btn">
          
          <span class="filter-text">{{ 'last_updated' | translate }} </span>
          <span class="date-text">{{ratingListLastUpdatedAt | date: 'dd MMMM yyyy'}}</span>
        </div>
        </div>
    </div>
  </div>

      <!-- Gender Tabs (Male / Female) -->
      <div id="st-rating-leaderboard-block">
        <div id="st-rating-leaderboard-tabs-container" class="tabs-container">
          <button
            class="tab-button"
            [class.active]="selectedGender === 1"
            (click)="selectGenderTab(1)" (keydown.enter)="selectGenderTab(1)" (keydown.space)="$event.preventDefault(); selectGenderTab(1)"
           tabindex="0">
            {{ 'male' | translate }}
          </button>
          <button
            class="tab-button"
            [class.active]="selectedGender === 2"
            (click)="selectGenderTab(2)" (keydown.enter)="selectGenderTab(2)" (keydown.space)="$event.preventDefault(); selectGenderTab(2)"
           tabindex="0">
            {{ 'female' | translate }}
          </button>
        </div>
      </div>

      <!-- Historical rating period banner (PRD 7.1) -->
      <div id="st-rating-leaderboard-historical-banner" class="historical-period-banner" *ngIf="isHistoricalPeriodActive">
        <span class="historical-period-text">
          {{ 'viewing_ratings_as_of' | translate }} {{ period?.value | date: 'dd/MM/yyyy' }}
        </span>
        <button class="back-to-latest-btn" (click)="backToLatest()">
          {{ 'back_to_latest' | translate }}
        </button>
      </div>

  <div id="st-rating-leaderboard-leaderboard-container" class="leaderboard-container d-none d-xl-block" *ngIf="showPodium()">
    <div id="st-rating-leaderboard-sch-main-container-expanded" class="sch-main-container-expanded d-flex align-items-center gap-2 w-100" [ngStyle]="podiumBackgroundNgStyle">
        <div id="st-rating-leaderboard-podium-container" class="podium-container w-100">
            <div id="st-rating-leaderboard-podium-cube" class="podium-cube second-place">
                <div id="st-rating-leaderboard-player-image-wrapper-second" class="player-image-wrapper-second">
                    <img
                        [src]="getPodiumPlayer(2)?.player_profile || '../../../assets/ranking-rating_assets/fallback_pfp.svg'"
                        alt="Player Profile" class="player-profile-pic-podium">
                </div>
                <div id="st-rating-leaderboard-podium-player-details" class="podium-player-details">
                    <div id="st-rating-leaderboard-participant-name-second-third" class="participant-name-second-third">{{ getPodiumPlayer(2)?.player }}</div>
                    <img
                      [src]="getPodiumPlayer(2)?.country_flag"
                      alt="Country Flag"
                      class="podium-country-flag"
                    />
                </div>
                <div id="st-rating-leaderboard-cube-content-second" class="cube-content-second">
                    <svg class="cube-svg" viewBox="0 0 303 103" width="100%" Height="100%" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M66.5 1L372.5 1.5L357 25V58L2 59L66.5 1Z" fill="#4D75AD" stroke="white" />
                        <path d="M2 138V58.9877L357 57.9999V138H2Z" fill="url(#paint0_linear_9652_81372)"
                            stroke="white" />
                        <defs>
                            <linearGradient id="paint0_linear_9652_81372" x1="183" y1="29.1887" x2="183"
                                y2="137.831" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#4D75AD" />
                                <stop offset="1" stop-color="#203047" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
                <div id="st-rating-leaderboard-badge-container-second" class="badge-container-second">
                    <div id="st-rating-leaderboard-block-1" class="d-flex align-items-center">
                        <div id="st-rating-leaderboard-block-2" class="medal">
                            <img src="../../../assets/BrandImages/second-medal.png" alt="Second Place Medal">
                        </div>
                        <div id="st-rating-leaderboard-rank2" class="rank2">{{ getPodiumPlayer(2)?.rank }}<sup>{{ getRankSuffix(getPodiumPlayer(2)?.rank || 2) }}</sup></div>
                        <div id="st-rating-leaderboard-points-info-side" class="points-info-side">
                            <span class="points-label">{{ 'points_earned' | translate }}:</span>
                            <span class="points-value">{{ getPodiumPlayer(2)?.points }}</span>
                            
                        </div>
                        <img
                                *ngIf="getPodiumPlayer(2)?.movementIndicator === '+'"
                                src="../../../assets/ranking-rating_assets/positive_indicator.svg"
                                alt="Rank Up"
                                class="podium-rank-indicator"
                            />
                            <img
                                *ngIf="getPodiumPlayer(2)?.movementIndicator === '-'"
                                src="../../../assets/ranking-rating_assets/negative_indicator.svg"
                                alt="Rank Down"
                                class="podium-rank-indicator"
                            />
                            <img
                                *ngIf="
                                    getPodiumPlayer(2)?.movementIndicator !== '+' &&
                                    getPodiumPlayer(2)?.movementIndicator !== '-'
                                "
                                src="../../../assets/ranking-rating_assets/nochange_indicator.svg"
                                alt="No Change"
                                class="podium-rank-indicator"
                            />
                    </div>
                </div>
            </div>

            <div id="st-rating-leaderboard-podium-cube-3" class="podium-cube first-place">
                <div id="st-rating-leaderboard-cube-content" class="cube-content">
                    <div id="st-rating-leaderboard-player-image-wrapper-first" class="player-image-wrapper-first">
                        <img
                            [src]="getPodiumPlayer(1)?.player_profile || '../../../assets/ranking-rating_assets/fallback_pfp.svg'"
                            alt="Player Profile" class="player-profile-pic-podium">
                    </div>
                    <div id="st-rating-leaderboard-podium-player-details-4" class="podium-player-details">
                        <div id="st-rating-leaderboard-participant-name" class="participant-name">{{ getPodiumPlayer(1)?.player }}</div>
                        <img
                      [src]="getPodiumPlayer(1)?.country_flag"
                      alt="Country Flag"
                      class="podium-country-flag-first"
                    />
                    </div>
                    <svg width="100%" height="100%" viewBox="0 0 438 220" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_d_9652_81426)">
                            <path d="M17 106L76.8522 16H360.651L421 106H17Z" fill="url(#paint0_linear_9652_81426)" />
                            <path d="M17 106L76.8522 16H360.651L421 106H17Z" stroke="white" />
                        </g>
                        <g filter="url(#filter1_d_9652_81426)">
                            <path d="M17 219V106H421V219H17Z" fill="url(#paint1_linear_9652_81426)" />
                            <path d="M17 219V106H421V219H17Z" stroke="white" />
                        </g>
                        <defs>
                            <filter id="filter0_d_9652_81426" x="0.966894" y="0.4" width="436.071"
                                height="121.2" filterUnits="userSpaceOnUse"
                                color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset />
                                <feGaussianBlur stdDeviation="7.55" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix"
                                    values="0 0 0 0 0.231373 0 0 0 0 0.509804 0 0 0 0 0.964706 0 0 0 0.2 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix"
                                    result="effect1_dropShadow_9652_81426" />
                                <feBlend mode="normal" in="SourceGraphic"
                                    in2="effect1_dropShadow_9652_81426" result="shape" />
                            </filter>
                            <filter id="filter1_d_9652_81426" x="1.4" y="90.4" width="435.2" height="144.2"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset />
                                <feGaussianBlur stdDeviation="7.55" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix"
                                    values="0 0 0 0 0.231373 0 0 0 0 0.509804 0 0 0 0 0.964706 0 0 0 0.2 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix"
                                    result="effect1_dropShadow_9652_81426" />
                                <feBlend mode="normal" in="SourceGraphic"
                                    in2="effect1_dropShadow_9652_81426" result="shape" />
                            </filter>
                            <linearGradient id="paint0_linear_9652_81426" x1="246" y1="105.829" x2="248.5"
                                y2="15.8286" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#4EA8F3" />
                                <stop offset="1" stop-color="#4D98D7" />
                            </linearGradient>
                            <linearGradient id="paint1_linear_9652_81426" x1="219" y1="54.8286" x2="219"
                                y2="219" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#62CFF4" />
                                <stop offset="1" stop-color="#2C67F2" />
                            </linearGradient>
                        </defs>
                    </svg>
                    <div id="st-rating-leaderboard-badge-container-first" class="badge-container-first">
                        <div id="st-rating-leaderboard-block-5" class="d-flex align-items-center gap-2">
                            <div id="st-rating-leaderboard-block-6" class="medal">
                                <img src="../../../assets/BrandImages/first_medal.png" alt="First Place Medal">
                            </div>
                            <div id="st-rating-leaderboard-rank" class="rank">{{ getPodiumPlayer(1)?.rank }}<sup>{{ getRankSuffix(getPodiumPlayer(1)?.rank || 1) }}</sup></div>
                        </div>
                        <div id="st-rating-leaderboard-block-7" class="d-flex align-items-center">
                        <div id="st-rating-leaderboard-points-info-below-rank" class="points-info-below-rank">
                            <span class="points-label">{{ 'points_earned' | translate }}:</span>
                            <span class="points-value">{{ getPodiumPlayer(1)?.points }}</span>
                            
                        </div>
                        <img
                                *ngIf="getPodiumPlayer(1)?.movementIndicator === '+'"
                                src="../../../assets/ranking-rating_assets/positive_indicator.svg"
                                alt="Rank Up"
                                class="podium-rank-indicator"
                            />
                            <img
                                *ngIf="getPodiumPlayer(1)?.movementIndicator === '-'"
                                src="../../../assets/ranking-rating_assets/negative_indicator.svg"
                                alt="Rank Down"
                                class="podium-rank-indicator"
                            />
                            <img
                                *ngIf="
                                    getPodiumPlayer(1)?.movementIndicator !== '+' &&
                                    getPodiumPlayer(1)?.movementIndicator !== '-'
                                "
                                src="../../../assets/ranking-rating_assets/nochange_indicator.svg"
                                alt="No Change"
                                class="podium-rank-indicator"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div id="st-rating-leaderboard-podium-cube-8" class="podium-cube third-place">
                <div id="st-rating-leaderboard-player-image-wrapper-third" class="player-image-wrapper-third">
                    <img
                        [src]="getPodiumPlayer(3)?.player_profile || '../../../assets/ranking-rating_assets/fallback_pfp.svg'"
                        alt="Player Profile" class="player-profile-pic-podium">
                </div>
                <div id="st-rating-leaderboard-podium-player-details-9" class="podium-player-details">
                    <div id="st-rating-leaderboard-participant-name-second-third-10" class="participant-name-second-third">{{ getPodiumPlayer(3)?.player }}</div>
                    <img
                      [src]="getPodiumPlayer(3)?.country_flag"
                      alt="Country Flag"
                      class="podium-country-flag"
                    />
                </div>
                <div id="st-rating-leaderboard-cube-content-11" class="cube-content">
                    <svg width="100%" height="100%" viewBox="0 0 303 103" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M229.762 1.5L1 0.5V56H301L229.762 1.5Z" fill="#092878" stroke="white" />
                        <path d="M301 102V56H1V102H301Z" fill="url(#paint0_linear_9652_81375)"
                            stroke="white" />
                        <defs>
                            <linearGradient id="paint0_linear_9652_81375" x1="156.779" y1="56.3226"
                                x2="156.779" y2="130.438" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#2045A5" />
                                <stop offset="1" stop-color="#010E2F" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
                <div id="st-rating-leaderboard-badge-container-third" class="badge-container-third">
                    <div id="st-rating-leaderboard-block-12" class="d-flex align-items-center">
                        <div id="st-rating-leaderboard-block-13" class="medal">
                            <img src="../../../assets/BrandImages/third_medal.png" alt="Third Place Medal">
                        </div>
                        <div id="st-rating-leaderboard-rank3" class="rank3">{{ getPodiumPlayer(3)?.rank }}<sup>{{ getRankSuffix(getPodiumPlayer(3)?.rank || 3) }}</sup></div>
                        <div id="st-rating-leaderboard-points-info-side-third" class="points-info-side-third">
                            <span class="points-label-third">{{ 'points_earned' | translate }}:</span>
                            <span class="points-value-third">{{ getPodiumPlayer(3)?.points }}</span>
                            
                        </div>
                        <img
                                *ngIf="getPodiumPlayer(3)?.movementIndicator === '+'"
                                src="../../../assets/ranking-rating_assets/positive_indicator.svg"
                                alt="Rank Up"
                                class="podium-rank-indicator-third"
                            />
                            <img
                                *ngIf="getPodiumPlayer(3)?.movementIndicator === '-'"
                                src="../../../assets/ranking-rating_assets/negative_indicator.svg"
                                alt="Rank Down"
                                class="podium-rank-indicator-third"
                            />
                            <img
                                *ngIf="
                                    getPodiumPlayer(3)?.movementIndicator !== '+' &&
                                    getPodiumPlayer(3)?.movementIndicator !== '-'
                                "
                                src="../../../assets/ranking-rating_assets/nochange_indicator.svg"
                                alt="No Change"
                                class="podium-rank-indicator-third"
                            />
                    </div>
                </div>
            </div>
        </div>
        </div>
  </div>



    
  <div id="st-rating-leaderboard-rating-table-container" *ngIf="ratings.length != 0 && !showRatingSkeleton" class="rating-table-container">
    <div id="st-rating-leaderboard-rating-grid"  class="rating-grid" [style.gridTemplateColumns]="getGridTemplateColumns()">
      <div *ngIf="worldRankEnabled" id="st-rating-leaderboard-grid-header-27" class="grid-header points" [title]="worldRankName">
        {{ worldRankAbbreviation }}
        <button type="button" class="st-btn-unstyled sort-icon-btn" (click)="toggleSortWorldRank()" (keydown.enter)="toggleSortWorldRank()" (keydown.space)="$event.preventDefault(); toggleSortWorldRank()" [attr.aria-label]="'Sort ' + worldRankName">
          <img
            src="../../../assets/ranking-rating_assets/sort_icon.svg"
            [alt]="'Sort ' + worldRankName"
            class="sort-icon"
          />
        </button>
      </div>
      <div id="st-rating-leaderboard-grid-header" class="grid-header rank">{{ 'rank' | translate | uppercase }}</div>
      <div id="st-rating-leaderboard-grid-header-14" class="grid-header player">{{ 'player' | translate | uppercase }}</div>
      <ng-container *ngIf="getDisplayableRoles().length > 0">
        <div [id]="'st-rating-leaderboard-grid-header-15' + (role)" *ngFor="let role of getDisplayableRoles(); trackBy: trackById" class="grid-header club-ma">
          {{ role.parent_role_name | uppercase }}
        </div>
      </ng-container>
      <ng-container *ngIf="getDisplayableRoles().length === 0">
        <div id="st-rating-leaderboard-grid-header-16" class="grid-header club-ma">
          {{ 'club' | translate | uppercase }}/MA
        </div>
      </ng-container>
      <div *ngIf="isAlternateRatingEnabled" id="st-rating-leaderboard-grid-header-17" class="grid-header points">
        {{alternateRatingName}}
        <button type="button" class="st-btn-unstyled sort-icon-btn" (click)="toggleSortAlternateRating()" (keydown.enter)="toggleSortAlternateRating()" (keydown.space)="$event.preventDefault(); toggleSortAlternateRating()" [attr.aria-label]="'Sort ' + alternateRatingName">
          <img
            src="../../../assets/ranking-rating_assets/sort_icon.svg"
            alt="Sort Points"
            class="sort-icon"
          />
        </button>
      </div>
      <div id="st-rating-leaderboard-grid-header-18" class="grid-header points">
        {{ 'rating_points' | translate | uppercase }}
        <button type="button" class="st-btn-unstyled sort-icon-btn" (click)="toggleSort()" (keydown.enter)="toggleSort()" (keydown.space)="$event.preventDefault(); toggleSort()" [attr.aria-label]="('sort' | translate) + ' ' + ('rating_points' | translate)">
          <img
            src="../../../assets/ranking-rating_assets/sort_icon.svg"
            alt="Sort Points"
            class="sort-icon"
          />
        </button>
      </div>

      <ng-container *ngIf="event_ids && event_ids.length > 0">
        <div [id]="'st-rating-leaderboard-grid-header-19' + (event)" class="grid-header event-points" *ngFor="let event of events; trackBy: trackById">
            {{ event.event_name | uppercase }}          
        </div>
      </ng-container>

      <div id="st-rating-leaderboard-grid-header-20" class="grid-header breakdown"></div>
    </div>
    <div [id]="'st-rating-leaderboard-rating-row' + (rating)" class="rating-row" *ngFor="let rating of ratings; trackBy: trackById" [style.gridTemplateColumns]="getGridTemplateColumns()">
      <div id="st-rating-leaderboard-grid-cell-28" *ngIf="worldRankEnabled" class="grid-cell points">{{ rating.world_rank ?? '—' }}</div>
      <div id="st-rating-leaderboard-grid-cell" class="grid-cell rank">
        <img
          *ngIf="rating.movementIndicator === '+'"
          src="../../../assets/ranking-rating_assets/positive_indicator.svg"
          alt="Rank Up"
          class="rank-indicator"
        />
        <img
          *ngIf="rating.movementIndicator === '-'"
          src="../../../assets/ranking-rating_assets/negative_indicator.svg"
          alt="Rank Down"
          class="rank-indicator"
        />
        <img
          *ngIf="
            rating.movementIndicator !== '+' &&
            rating.movementIndicator !== '-'
          "
          src="../../../assets/ranking-rating_assets/nochange_indicator.svg"
          alt="No Change"
          class="rank-indicator"
        />
        <span class="rank-number">{{ rating.rank }}</span>
      </div>
      <div id="st-rating-leaderboard-grid-cell-21" class="grid-cell player">
        <img
          [src]="
            rating.player_profile ||
            '../../../assets/ranking-rating_assets/fallback_pfp.svg'
          "
          alt="Player Profile"
          class="player-profile-pic"
        />
        <span class="player-name">{{ rating.player }}</span>
        <img
          *ngIf="rating.is_paused"
          src="../../../assets/ranking-rating_assets/pause_player.svg"
          alt="Paused Player"
          class="pause-icon"
        />
      </div>
      <ng-container *ngIf="getDisplayableRoles().length > 0">
        <div [id]="'st-rating-leaderboard-grid-cell-22' + (role)" *ngFor="let role of getDisplayableRoles(); trackBy: trackById" class="grid-cell club-ma">
          {{ getParentValueForRole(rating, role.parent_role_id) }}
        </div>
      </ng-container>
      <ng-container *ngIf="getDisplayableRoles().length === 0">
        <div id="st-rating-leaderboard-grid-cell-23" class="grid-cell club-ma">
          <img
            [src]="rating.country_flag"
            alt="Country Flag"
            class="country-flag"
          />
          {{ rating.clubMa }}
        </div>
      </ng-container>
      <div id="st-rating-leaderboard-grid-cell-24"  *ngIf="isAlternateRatingEnabled" class="grid-cell points">{{ rating.alternate_rating }}</div>
      <div id="st-rating-leaderboard-grid-cell-25" class="grid-cell points">{{ rating.points }}<span class="provisional">{{rating.status ? rating.status != 'active'? '*':'' : ''}}</span></div>
      <ng-container *ngIf="event_ids && event_ids.length > 0">
        <div [id]="'st-rating-leaderboard-grid-cell-26' + (event)" class="grid-cell event-points" *ngFor="let event of events; trackBy: trackById" >
            {{ ratingPointsExist(rating, event) ? rating.event_points[event.event_id]: '-'}}
        </div>
      </ng-container>
      <div id="st-rating-leaderboard-grid-cell-27" class="grid-cell breakdown">
        <button type="button" (click)="onBreakdownClick(rating)" (keydown.enter)="onBreakdownClick(rating)" (keydown.space)="$event.preventDefault(); onBreakdownClick(rating)"><img src="../../../assets/ranking-rating_assets/point_breakdown.svg" alt="Breakdown Details" class="breakdown-btn" /></button>
      </div>
    </div>
    
    <div id="st-rating-leaderboard-pagination-container" *ngIf="ratings.length != 0" class="pagination-container">
      <div id="st-rating-leaderboard-pagination-buttons" class="pagination-buttons">
        <button
          class="pagination-btn"
          (click)="goToFirstPage()" (keydown.enter)="goToFirstPage()" (keydown.space)="$event.preventDefault(); goToFirstPage()"
          [disabled]="currentPage === 1"
         tabindex="0">
          <img
            src="../../../assets/ranking-rating_assets/navigation_arrow2.svg"
            alt="First Page"
            class="pagination-icon double-arrow left"
          />
        </button>
        <button
          class="pagination-btn"
          (click)="prevPage()" (keydown.enter)="prevPage()" (keydown.space)="$event.preventDefault(); prevPage()"
          [disabled]="currentPage === 1"
         tabindex="0">
          <img
            src="../../../assets/ranking-rating_assets/navigation_arrow.svg"
            alt="Previous Page"
            class="pagination-icon single-arrow left"
          />
        </button>
        <button
          *ngFor="let page of getPageNumbers(); trackBy: trackById"
          class="pagination-btn"
          [ngClass]="{ active: currentPage === page }"
          (click)="goToPage(page)" (keydown.enter)="goToPage(page)" (keydown.space)="$event.preventDefault(); goToPage(page)"
         tabindex="0">
          {{ page }}
        </button>
        <button
          class="pagination-btn"
          (click)="nextPage()" (keydown.enter)="nextPage()" (keydown.space)="$event.preventDefault(); nextPage()"
          [disabled]="currentPage === totalPages"
         tabindex="0">
          <img
            src="../../../assets/ranking-rating_assets/navigation_arrow.svg"
            alt="Next Page"
            class="pagination-icon single-arrow right"
          />
        </button>
        <button
          class="pagination-btn"
          (click)="goToLastPage()" (keydown.enter)="goToLastPage()" (keydown.space)="$event.preventDefault(); goToLastPage()"
          [disabled]="currentPage === totalPages"
         tabindex="0">
          <img
            src="../../../assets/ranking-rating_assets/navigation_arrow2.svg"
            alt="Last Page"
            class="pagination-icon double-arrow right"
          />
        </button>
      </div>
      <div id="st-rating-leaderboard-items-per-page" class="items-per-page d-none d-md-block">
        <span>{{ getStartIndex() }} - &nbsp;</span>
        <select
          [(ngModel)]="itemsPerPage"
          (ngModelChange)="onItemsPerPageChange()"
          class="items-per-page-dropdown"
          aria-label="Items per page"
        >
          <option *ngFor="let option of itemsPerPageOptions; trackBy: trackById" [value]="option">
            {{ option }}
          </option>
        </select>
        <span> {{ 'of' | translate }} {{ totalItems }}</span>
        <span *ngIf="isRowFiltered" class="filtered-count-note">
          ({{ 'filtered_from' | translate }} {{ unfilteredTotalCount }})
        </span>
      </div>
    </div>
  </div>
  @if (showRatingSkeleton) {
  <stupa-skeleton-loader id="st-rating-leaderboard-loading-leaderboard" class="p-3" [rows]="10" />
  }
  <div id="st-rating-leaderboard-norecord"
      *ngIf="ratings.length === 0 && !showRatingSkeleton"
      class="norecord d-flex flex-column align-items-center text-center w-100 justify-content-center"
      style="margin-top: 120px; margin-bottom: 120px"
    >
      <img
        src="../../../assets/ranking-rating_assets/no_record_found.svg"
        alt="No Records"
      />
      <p class="no-record" *ngIf="!areFiltersApplied">{{'ranking_standing_no_data_available' | translate}}</p>
      <ng-container *ngIf="areFiltersApplied">
        <p class="no-record">{{'no_players_match_filters' | translate}}</p>
        <button class="back-to-latest-btn" (click)="removeFilters()">
          {{ 'clear_all' | translate }}
        </button>
      </ng-container>
  </div>

<stupa-breadown-sidebar
  *ngIf="isBreakdownSidebarOpen"
  [playerData]="selectedPlayerForBreakdown"
  (panelClose)="isBreakdownSidebarOpen = false"
  [appliedFilters]="appliedFilters"
></stupa-breadown-sidebar>

<stupa-breakdown-filter-sidebar
  *ngIf="isFilterSidebarOpen"
  (panelClose)="isFilterSidebarOpen = false"
  (applyFilters)="applyFilters($event)"
  [totalItems]="totalItems"
  [parents]="parents"
  [parent_role_list]="parent_role_list"
  [clubsRoleId]="clubsRoleId"
  [rank_range]="rank_range"
  [period]="period"
  [filterEventIds]="event_ids"
  [genders]="genders"
  [ages]="ages"
  [category_id]="category_id"
  [player_category]="player_category"
  [publishedDates]="publishedDates"
  [selectedCategoryLevelId]="selectedCategoryLevelId"
  [selectedCategoryLevelName]="selectedCategoryLevelName"
  [filterConfig]="filterConfig"
  [classificationFields]="classificationFields"
  [classification_filters]="classification_filters"
></stupa-breakdown-filter-sidebar>
</div>